import { LocalStorage } from 'libs/common';
import { Draggable } from 'libs/ui';
import { ZoneRow } from './zone-row/zone-row';
import { Content, Name, Zones } from './counter.styled';

const storage = new LocalStorage('counters');

window.lastCounterY = 30;
window.lastCounterH = 0;

export const Counter = (props) => {
  const { index, data, scale, ...rest } = props;
  const { client_name, client_id } = data;
  const wide = client_id !== 'oneTimeAll' && client_id !== 'regularAll';

  // const node = window.config.objects.zones.find((item) => {
  //   return item.zoneId.toString() === window.zone_id.toString();
  // });

  const getCoord = () => {
    const saved = storage.getItem(client_id);
    // console.log("🚀 ~ getCoord ~ saved:", saved)
    if (saved) {
      return saved;
    }
    if (index === 0) {
      window.lastCounterY = 30;
    }
    const odd = index % 2;
    const x = odd ? 0 : 267; //180; //window.innerWidth - 240;
    const h = Math.max(data.items.length * 20 + 14 + 15 + 15, window.lastCounterH);
    const y = window.lastCounterY;
    if (odd) {
      window.lastCounterY += h;
    }
    window.lastCounterH = h;
    storage.setItem(client_id, { x, y });
    return { x, y };
  };

  const getItemsEl = () => {
    return data.items.map((el, idx) => <ZoneRow key={idx} {...el} />);
  };

  const setCoord = (_event, el) => {
    // console.log('🚀 ~ setCoord ~ event:', el);
    const { x, y } = el;
    storage.setItem(client_id, { x, y });
  };

  const { x, y } = getCoord();
  // console.log('🚀 ~ Counter ~ x, y:', x, y, client_id);
  const itemsEl = getItemsEl();

  return (
    <Draggable defaultPosition={{ x, y }} scale={scale} onStop={setCoord} width={wide ? '247px' : '165px'}>
      <Content {...rest} style={{ width: wide ? '247px' : '165px' }}>
        <Name title={client_name}>{client_name}</Name>
        <Zones>{itemsEl}</Zones>
      </Content>
    </Draggable>
  );
};
